import React, { useCallback, useState } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { FlightDropdownOption } from 'components/Flights/types'

import InlineGroup from 'components/Common/InlineGroup'
import Clickable from 'components/Common/Clickable'
import FareDropdownMobileMenu from './FareDropdownMobileMenu'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LineAngleDownIcon from 'components/Luxkit/Icons/line/LineAngleDownIcon'

const FareDropdownToggle = styled(Clickable)`
  height: ${rem(36)};
  display: flex;
  align-items: center;
`

const StyledLineAngleDownIcon = styled(LineAngleDownIcon)`
  margin-left: ${rem(8)};
`

interface Props {
  options: Array<FlightDropdownOption>;
  selectedOption: FlightDropdownOption;
  className?: string;
  title: string;
  onOptionChange: (option: FlightDropdownOption) => void;
}

function FareDropdownMobile(props: Props) {
  const { options, selectedOption, className, title, onOptionChange } = props
  const [isOpen, setOpen] = useState(false)
  const [option, setOption] = useState(selectedOption)

  const handleOpen = useCallback(() => setOpen(true), [setOpen])

  const handleClose = useCallback(() => {
    setOpen(false)
    setOption(selectedOption)
  }, [setOpen, setOption, selectedOption])

  const onApply = useCallback(() => {
    setOpen(false)
    onOptionChange(option)
  }, [setOpen, onOptionChange, option])

  return (
    <InlineGroup className={className}>
      <FareDropdownToggle onClick={handleOpen}>
        <BodyText variant="medium" weight="bold">{selectedOption.label}</BodyText>
        <StyledLineAngleDownIcon />
      </FareDropdownToggle>

      <FareDropdownMobileMenu
        open={isOpen}
        options={options}
        selectedOption={option}
        title={title}
        onClose={handleClose}
        onOptionChange={setOption}
        onApply={onApply}
      />
    </InlineGroup>
  )
}

export default FareDropdownMobile
